/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_List_EmptyInputs */

const vi_reconcile_list_empty = /** @type {(inputs: Reconcile_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có khoản CK nào chờ đối soát`)
};

/**

* @param {Reconcile_List_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_list_empty = /** @type {((inputs?: Reconcile_List_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_List_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_list_empty(inputs)
});